import React from "react";
import "../styles/pulu-keeling.scss";
import Layout from './layout';

export default function PageLayout({ children }) {
  return <Layout>{children}</Layout>;
}
